<div class="stack">
  <img [@stackAdd]="this.added ? 'added' : null" class="playing-card" id="playing-card" [src]="cards[0].cardPath"
    (click)="onCardClick(cards)" [class.selected]="cards === selectedStack" />
</div>